import { render, staticRenderFns } from "./StudentStatementList.vue?vue&type=template&id=02297dda"
import script from "../../../controllers/custom/student_statement/student-statement-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/student_statement/student-statement-list.js?vue&type=script&lang=js&external"
import style0 from "./StudentStatementList.vue?vue&type=style&index=0&id=02297dda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports